module.exports = __webpack_public_path__ + "img/m.dfb01657.jpg";